import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useShouldShowBestPriceGuarantee} from '../BestPriceHintSection/useShouldShowBestPriceGuarantee';
import {useUSPsSection} from '../useGetProductBulkSection';
import {QuickViewUSPsView} from './QuickViewUSPsView';

export const QuickViewUSPs: React.FC = () => {
  const shouldShowBestPriceGuarantee = useShouldShowBestPriceGuarantee();
  // the Usps on the quick view should not be rendered if the best price section is available - https://aboutyou.atlassian.net/browse/ASFE-9581
  if (shouldShowBestPriceGuarantee) {
    return null;
  }

  return <QuickViewUSPsRequest />;
};

const QuickViewUSPsRequest = () => {
  return (
    <DataFetcher
      request={useUSPsSection()}
      Error={null}
      View={QuickViewUSPsView}
    />
  );
};
